import styled, { css } from 'styled-components';
const RoundedCertificationBadge = styled.div.attrs({
  'data-test-id': 'my-team-certification-icon'
}).withConfig({
  displayName: "RoundedCertificationBadge",
  componentId: "ql72b7-0"
})(["border-radius:50%;aspect-ratio:1 / 1;background-color:", ";background-image:url('https://hubspot-academy.s3.amazonaws.com/prod/tracks/icons/5-1630752774293.png');background-size:cover;background-position:center;width:", ";height:", ";", ""], ({
  theme
}) => theme.color['fill-surface-raised'], ({
  theme,
  size
}) => theme.space[size], ({
  theme,
  size
}) => theme.space[size], ({
  iconUrl
}) => iconUrl && css(["background-image:url(", ");"], iconUrl));
export default RoundedCertificationBadge;